// Heads-up display: score, combo, marshmallows toasted, and burns remaining.
// Minimal text rendering; reads sim stats each frame.

import Phaser from 'phaser';

export interface HudStats {
  score: number;
  combo: number;
  marshmallowsDone: number;
  burnsRemaining: number;
}

export class Hud {
  private scoreText: Phaser.GameObjects.Text;
  private comboText: Phaser.GameObjects.Text;
  private burnsText: Phaser.GameObjects.Text;

  constructor(private scene: Phaser.Scene) {
    this.scoreText = scene.add
      .text(16, 14, '', { fontFamily: 'system-ui', fontSize: '24px', color: '#f5e6c8' })
      .setScrollFactor(0)
      .setDepth(10);
    this.comboText = scene.add
      .text(16, 46, '', { fontFamily: 'system-ui', fontSize: '16px', color: '#ffb347' })
      .setScrollFactor(0)
      .setDepth(10);
    this.burnsText = scene.add
      .text(0, 14, '', { fontFamily: 'system-ui', fontSize: '16px', color: '#ff8c6b' })
      .setOrigin(1, 0)
      .setScrollFactor(0)
      .setDepth(10);
    this.layout();
  }

  layout(): void {
    this.burnsText.setX(this.scene.scale.gameSize.width - 16);
  }

  update(stats: HudStats): void {
    this.scoreText.setText(`Score ${stats.score}`);
    this.comboText.setText(
      stats.combo > 0 ? `Combo x${stats.combo}  ·  toasted ${stats.marshmallowsDone}` : `toasted ${stats.marshmallowsDone}`,
    );
    const hearts = '♥'.repeat(Math.max(0, stats.burnsRemaining));
    this.burnsText.setText(`burns left ${hearts || '—'}`);
  }

  destroy(): void {
    this.scoreText.destroy();
    this.comboText.destroy();
    this.burnsText.destroy();
  }
}
